import { useSandboxDialog } from './logic/useSandboxDialog'
import { SandboxDialogView } from './views/SandboxDialogView'

export interface SandboxDialogContentContainerProps {
  closeDialog: () => void
}

export function SandboxDialogContentContainer({ closeDialog }: SandboxDialogContentContainerProps) {
  const {
    isInSandbox,
    inputAddressExtension,
    cloneVnetExtension,
    startSandbox,
    isPending,
    isSuccess,
    isError,
    error,
    activateButtonEnabled,
  } = useSandboxDialog()
  return (
    <SandboxDialogView
      isInSandbox={isInSandbox}
      inputAddressExtension={inputAddressExtension}
      cloneVnetExtension={cloneVnetExtension}
      startSandbox={startSandbox}
      closeDialog={closeDialog}
      isPending={isPending}
      isSuccess={isSuccess}
      isError={isError}
      error={error}
      activateButtonEnabled={activateButtonEnabled}
    />
  )
}
